import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { getIsMobile, defaultGameFilter } from "@nxplatform/helpers/helpers-pure";
import { fetchCasinoMyFavoritesGames, fixedDevIds, clearMyFavoritesGamesList } from "@nxplatform/casino/casino-category.slice";
const useCasinoGetMyFavoritesGamesHook = ({
  auth
}) => {
  const dispatch = useDispatch();
  const isMobile = getIsMobile();
  useEffect(() => {
    if (auth) {
      dispatch(fetchCasinoMyFavoritesGames({
        ...defaultGameFilter(),
        per_page: isMobile ? 8 : 25,
        dev_id: fixedDevIds.myFavorites
      }));
    }
    if (!auth) {
      clearMyFavoritesGamesList();
    }
  }, [isMobile, auth]);
};
export {
  useCasinoGetMyFavoritesGamesHook
};
